import type { MarketingPageLanguage } from "../../marketing-content/marketingContentLoader";
import { MARKETING_LOCALES } from "../../marketing-content/marketingLocales";
import { getMarketingTranslations } from "../../marketing-content/marketingTranslations";

export function getMarketingSiteCopy(lang: MarketingPageLanguage) { return getMarketingTranslations(lang).site; }
export function getMarketingHomeRoute(lang: MarketingPageLanguage): string { return MARKETING_LOCALES[lang].home; }

/**
 * Formats an ISO `YYYY-MM-DD` published date for display in the page's language, e.g.
 * "February 27, 2024" / "27 de febrero de 2024". The date is built from its parts so it is not
 * shifted by the visitor's time zone (`new Date("2024-02-27")` would be UTC midnight, which is
 * still the 26th in the Americas). Unparseable input is returned as-is.
 */
export function formatMarketingPublishedDate(isoDate: string, lang: MarketingPageLanguage): string {
  const isoDateMatch = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!isoDateMatch) return isoDate;
  const [, year, month, day] = isoDateMatch;
  const localDate = new Date(Number(year), Number(month) - 1, Number(day));
  try {
    return new Intl.DateTimeFormat(lang, { dateStyle: "long" }).format(localDate);
  } catch {
    return isoDate;
  }
}
